var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarginaliaVirtualReality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 191,
    viewBox: "0 0 195 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.52588e-05 0H195V190.491H-1.52588e-05V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.8937 14.235V156.097H181.106V14.235H13.8937ZM13.3574 13.6987H181.642V156.658H13.3574V13.6987Z",
    fill: "#C4ECFE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 115.026H181.642V115.538H13.3574V115.026Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 94.575H181.642V95.0869H13.3574V94.575Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 115.026H181.642V115.538H13.3574V115.026Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 135.501H181.642V136.012H13.3574V135.501Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 74.1H181.642V74.6119H13.3574V74.1Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 53.625H181.642V54.1369H13.3574V53.625Z",
    fill: "#C4ECFE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3574 33.15H181.642V33.6618H13.3574V33.15Z",
    fill: "#C4ECFE"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M162.094 88.335C165.336 88.335 168.066 85.7025 170.942 82.9237C174.111 79.8281 177.426 76.6594 181.667 76.6594V74.9044C176.694 74.9044 172.989 78.5119 169.699 81.6806C167.091 84.1912 164.629 86.58 162.094 86.58V88.335Z",
    fill: "#F9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.61 27.2025V25.4475C36.075 25.4475 33.6131 23.0587 31.005 20.5481C27.7144 17.3794 24.0093 13.7719 19.0368 13.7719V15.5269C23.3025 15.5269 26.5931 18.72 29.7862 21.8156C32.6381 24.57 35.3437 27.2025 38.61 27.2025Z",
    fill: "#F9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.179 29.25C181.179 21.1088 173.989 12.6019 164.848 17.9156C155.732 23.205 158.974 31.5413 143.91 33.6375H181.179V29.25Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.637 45.9713C151.637 40.3894 144.714 37.7325 141.034 41.925C139.181 44.0212 137.158 45.5569 133.965 44.7769C121.29 41.6812 123.63 54.5513 113.197 54.8681H144.397C148.395 54.8681 151.637 51.6262 151.637 47.6287V45.9713Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.029 156.634C158.316 156.634 158.023 142.569 166.091 140.693C169.309 139.961 171.064 137.573 172.575 134.964C175.061 130.65 181.642 132.381 181.642 137.378V156.634H149.029Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9638 53.5031H34.7588C26.7882 53.5031 20.3044 59.9869 20.3044 67.9575V156.634H72.3938V67.9331C72.3938 59.9625 65.9344 53.5031 57.9638 53.5031Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5669 67.9331V156.609H81.6807V67.9331C81.6807 59.9625 75.2213 53.4788 67.2507 53.4788C67.2263 53.4788 67.2263 53.4788 67.2263 53.4788H44.0213C36.0507 53.5031 29.5669 59.9625 29.5669 67.9331Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9918 78.0731C52.1625 86.6287 52.5281 87.8719 52.5281 87.8719L61.6931 87.3844L69.3712 65.7881L71.0531 55.0631L70.8337 53.9419C69.6637 53.6494 68.445 53.5031 67.2506 53.5031H61.8637C60.9618 53.5031 60.2306 54.1856 60.1575 55.0875L60.0843 55.9894C60.0112 56.8912 59.4018 57.6469 58.5243 57.8662C57.7931 58.0612 56.9156 58.4025 56.4037 58.9387C52.3575 63.2044 51.8212 69.5175 51.9918 78.0731Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4399 106.397H101.497V156.658H37.4399V106.397Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.128 85.5319H106.836C103.74 85.5319 101.254 88.0425 101.254 91.1137V156.634H112.71V91.1137C112.71 88.0181 110.224 85.5319 107.128 85.5319C107.152 85.5319 107.128 85.5319 107.128 85.5319Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3893 155.854H181.642V156.634H79.3893V155.854Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.233 64.1794L110.589 65.1056L80.1206 58.7438C76.1719 57.7931 72.1988 60.2306 71.2725 64.1794C70.3463 68.1281 72.7594 72.1013 76.7081 73.0275L109.298 79.9013L109.639 79.9988C111.053 80.34 112.539 80.1938 113.831 79.56L138.109 75.8063L135.233 64.1794Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.109 75.8063L142.984 74.5631C146.055 73.7831 147.932 70.6875 147.152 67.6163C146.421 64.7644 143.666 62.9119 140.741 63.3506L135.232 64.1794L138.109 75.8063Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9894 139.108L76.9032 126.701C75.9525 126.043 75.7088 124.751 76.3182 123.801L77.8294 121.461L89.1882 129.431L96.3788 137.499C97.2319 138.45 96.0375 139.815 94.9894 139.108Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0474 119.048C79.9012 119.121 85.6293 131.138 86.2387 132.429L87.4574 131.942L88.6031 131.479C89.3587 131.162 90.1143 130.869 90.8699 130.528C98.5968 127.189 107.494 123.313 113.758 117.512C119.389 112.296 123.167 104.374 121.363 96.915C119.535 89.3588 112.393 83.9963 104.861 82.0219C102.253 81.3638 99.5718 80.9738 96.8662 80.8519C94.1118 80.73 91.3574 80.7788 88.6031 80.9738C86.7749 81.0957 84.8737 81.0225 82.9481 81.0225C81.3637 80.9982 79.7793 81.0957 78.1949 81.315C78.7312 83.9719 82.1681 108.274 83.0456 108.42C83.0699 108.396 83.0699 108.396 83.0943 108.396C87.9206 106.884 93.0149 107.031 97.9874 106.324C93.3806 111.881 85.8243 115.879 80.0474 119.048Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0612 86.4094C58.4512 90.7725 63.5944 96.915 71.2237 96.33L77.3662 95.6475C84.3131 95.1112 89.3587 88.4081 88.9444 83.7037L65.6419 86.1169L58.0612 86.4094Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9725 81.0469V87.0675C82.9725 87.0675 95.7937 93.9657 93.5512 89.7488C91.3575 85.6294 94.4775 81.9488 96.8662 80.8519C94.1118 80.73 91.3575 80.7788 88.6031 80.9738C86.775 81.12 84.8737 81.0469 82.9725 81.0469Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.985 135.988H113.929C119.73 135.988 124.995 132.503 127.238 127.164L131.869 116.537C132.673 114.684 131.844 112.515 129.968 111.711C128.091 110.906 125.946 111.735 125.141 113.612L120.486 124.239C120.486 124.264 120.461 124.264 120.461 124.264C119.34 126.921 116.781 128.627 113.904 128.627H101.961C99.9375 128.627 98.28 130.26 98.28 132.308C98.2557 134.355 99.9375 135.988 101.985 135.988Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5843 113.539V130.284H113.709C114.489 130.284 115.269 130.211 116.049 130.065C121.826 128.944 125.97 123.898 125.97 118.024V112.417L121.582 112.515L116.196 112.637L79.5843 113.539Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5844 92.7225V114.124H121.631C121.924 114.124 122.192 114.124 122.484 114.099C123.654 114.075 124.922 114.148 125.994 113.856C132.161 112.174 136.427 106.177 136.232 99.4987C136.134 95.7694 135.622 90.2362 134.209 87.0919C131.381 80.8031 125.726 85.6294 121.631 85.7512H103.472C94.9894 85.7269 86.7019 88.14 79.5844 92.7225Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.342 114.124L130.626 113.856V108.688L121.802 98.3287L117.317 98.5969L116.342 114.124Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.472 85.7269L134.843 84.4838L137.499 94.4775L116.342 94.5994L103.472 85.7269Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.581 98.0606H136.11C136.11 98.0606 137.158 104.325 132.941 109.176L123.581 98.0606Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8443 127.652H104.179C106.494 127.652 108.615 126.311 109.687 124.166L111.272 120.998C112.588 118.389 110.784 115.269 107.981 115.269H96.9637C95.5743 115.294 94.2824 116.098 93.6731 117.341L90.5043 123.63C89.6268 125.458 90.8943 127.652 92.8443 127.652Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2332 119.389H108.761C109.176 119.364 109.493 119.023 109.468 118.609C109.444 118.243 109.151 117.926 108.761 117.902H95.2332C94.8188 117.878 94.4775 118.194 94.4532 118.609C94.4288 119.023 94.7457 119.364 95.16 119.389C95.16 119.389 95.1844 119.389 95.2332 119.389Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9656 122.192H107.494C107.908 122.216 108.249 121.899 108.274 121.485C108.298 121.071 107.981 120.729 107.567 120.705C107.542 120.705 107.518 120.705 107.494 120.705H93.9656C93.5512 120.729 93.2343 121.071 93.2587 121.485C93.3075 121.875 93.6 122.168 93.9656 122.192Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7468 125.019H106.275C106.689 125.044 107.031 124.727 107.055 124.313C107.079 123.898 106.762 123.557 106.348 123.533C106.324 123.533 106.299 123.533 106.275 123.533H92.7468C92.3325 123.557 92.0156 123.898 92.04 124.313C92.04 124.703 92.3568 124.995 92.7468 125.019Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0168 87.8231L94.0143 90.0169L100.986 114.221L84.1668 130.284L109.468 131.357L116.342 114.099C120.047 109.346 120.949 103.74 121.022 102.448C121.972 89.0906 108.054 85.7025 103.447 85.7025C98.9137 85.7269 94.38 86.4338 90.0168 87.8231Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5843 114.367H125.994C126.141 114.367 126.262 114.246 126.262 114.099C126.262 113.953 126.141 113.831 125.994 113.831H79.5843C79.4381 113.831 79.3162 113.953 79.3162 114.099C79.3162 114.246 79.4381 114.367 79.5843 114.367Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.349 128.651H79.56V135.988H104.349C110.151 135.988 115.416 132.502 117.658 127.164L122.289 116.537C122.631 115.757 122.704 114.904 122.46 114.075C121.924 112.125 119.876 110.979 117.926 111.564C116.878 111.857 116.001 112.612 115.562 113.636L115.342 114.124L110.906 124.288C110.906 124.312 110.882 124.312 110.882 124.312C109.809 126.945 107.226 128.651 104.349 128.651Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2588 128.676L83.9232 136.061L80.6813 130.382L87.7744 128.213L93.2588 128.676Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9443 83.6794C88.2131 75.3919 82.6068 76.7813 84.3131 71.0288C86.0193 65.2763 82.8018 57.6956 76.44 58.2319C71.5406 58.6706 71.175 58.5 69.1275 58.6706C63.9356 59.1338 59.3043 58.2319 57.72 69.3713C57.3056 72.2232 58.2806 82.9481 58.11 86.385L65.8612 87.0432L88.9443 83.6794Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4837 75.2457C84.5081 75.2457 84.5081 75.2457 84.5081 75.2457C84.6544 75.2213 84.7519 75.0994 84.7275 74.9532C84.5081 72.93 84.9712 67.3482 84.9712 67.2994C84.9956 67.1532 84.8737 67.0069 84.7275 67.0069C84.5812 66.9825 84.435 67.1044 84.435 67.2507C84.4106 67.47 83.9475 72.93 84.1912 75.0019C84.24 75.1238 84.3375 75.2457 84.4837 75.2457Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4882 58.2319C77.4882 58.2319 79.2675 58.2319 82.2169 59.3775L76.9519 62.9363L77.4882 58.2319Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4656 63.4481L66.9825 60.9862L68.0306 53.4056L76.4156 49.7006L77.7806 60.7912C77.9025 62.205 76.8544 63.4481 75.4406 63.57C75.1238 63.5944 74.8069 63.5456 74.4656 63.4481Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9269 55.9894L73.2225 56.2331L77.805 60.7913L77.9269 55.9894Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7625 43.2413L68.0794 51.9188C68.1769 54.8925 70.6875 57.2082 73.6613 57.1107L79.4138 56.8913C82.7775 56.7694 85.41 53.9175 85.2882 50.5538L85.1175 46.0444L85.0444 44.1432L84.9957 42.6075C84.825 37.9519 80.9982 34.2957 76.3913 34.2957C76.2938 34.2957 76.1719 34.2957 76.0744 34.2957C71.2969 34.4907 67.5919 38.4882 67.7625 43.2413Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3131 45.0937C84.3131 45.5812 84.6543 45.9712 85.1174 46.0687L85.0443 44.1675C84.6299 44.265 84.3131 44.6306 84.3131 45.0937Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9969 48.1406C83.0457 48.1406 83.0944 48.1162 83.1432 48.1162L83.9719 47.58C84.1669 47.4094 84.2644 47.19 84.2644 46.9219C84.2644 46.6537 84.1913 46.4344 84.0207 46.2637L82.7532 44.85C82.6557 44.7525 82.485 44.7281 82.3875 44.8256C82.29 44.9231 82.2656 45.0937 82.3631 45.1912L83.6307 46.605C83.7769 46.7756 83.7769 47.0194 83.6063 47.1656L82.8506 47.6531C82.7288 47.7262 82.68 47.8969 82.7775 48.0187C82.8507 48.0919 82.9238 48.1406 82.9969 48.1406Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1918 51.3337C83.265 51.3337 83.3625 51.3337 83.4112 51.3094C83.9475 51.2119 84.3862 50.8462 84.7031 50.2125C84.7762 50.0906 84.7275 49.92 84.5812 49.8712C84.4593 49.7981 84.2887 49.8469 84.24 49.9931C83.9962 50.4806 83.7037 50.7487 83.3381 50.7975C82.6312 50.895 81.8756 50.1637 81.8756 50.1394C81.7781 50.0419 81.6075 50.0419 81.51 50.1394C81.4125 50.2369 81.4125 50.4075 81.51 50.505C81.5343 50.5537 82.3143 51.3337 83.1918 51.3337Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6819 46.3125C79.1434 46.3125 78.7069 45.876 78.7069 45.3375C78.7069 44.799 79.1434 44.3625 79.6819 44.3625C80.2203 44.3625 80.6569 44.799 80.6569 45.3375C80.6569 45.876 80.2203 46.3125 79.6819 46.3125Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8012 38.5612C84.3374 39.9019 82.5093 40.1944 80.3643 39.975C77.7074 39.6825 75.2943 41.6081 75.0018 44.2406C75.0018 44.2894 74.9774 44.3625 74.9774 44.4112C74.9287 45.1912 74.4656 45.8494 73.7587 46.1906L72.0768 46.995L71.2724 51.0656C70.9556 52.6987 69.5174 53.8931 67.8599 53.8931C67.8599 53.8931 67.7137 45.7519 67.7137 42.2419C67.7137 38.7319 70.6143 34.6125 76.0499 34.2956C81.4856 33.9787 83.8012 38.5612 83.8012 38.5612Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8818 43.2413H77.2931V46.1419H71.8818V43.2413Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0038 43.2413C71.1994 43.2656 70.5656 43.9238 70.5656 44.7525L70.6388 47.2631C70.6631 48.0675 71.3213 48.7013 72.15 48.7013C72.9544 48.6769 73.5881 48.0188 73.5881 47.19L73.515 44.6794C73.4906 43.8506 72.8325 43.1925 72.0038 43.2413Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0969 102.765L78.5606 114.636C83.8013 114.27 89.2856 106.689 89.2856 106.689L79.0969 102.765Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0613 86.4094L58.3294 92.7712C58.6219 100.011 64.4719 105.812 71.7113 106.08L87.5794 106.689L71.6381 120.754L81.9244 131.722C81.9244 131.722 116.415 118.633 115.318 103.228C114.221 87.8231 93.9413 85.0444 58.0613 86.4094Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7519 142.618L70.9313 125.604C70.2 124.702 70.3219 123.411 71.1994 122.655L73.3444 119.706L81.9488 131.698L86.58 141.497C87.0675 142.643 85.5319 143.593 84.7519 142.618Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5606 106.958H92.43C92.5763 106.958 92.6981 106.836 92.6981 106.689C92.6981 106.543 92.5763 106.421 92.43 106.421H78.5606C78.4144 106.421 78.2925 106.543 78.2925 106.689C78.2925 106.836 78.4144 106.958 78.5606 106.958Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.05 34.32C75.27 34.2956 73.9782 34.3931 70.7119 34.3931C67.4457 34.3931 68.7863 40.0481 64.4232 40.0481C61.4738 40.0481 57.3788 45.4838 61.9613 48.7013C65.0569 50.8706 63.7163 53.9175 67.8113 53.9175L69.5907 42.6563L75.4894 35.5388L76.05 34.32Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4144 47.8725H78.7312C79.2675 47.8725 79.8037 47.7019 80.2425 47.385L80.7543 47.0194C81.6562 46.3612 84.1669 46.3612 85.0687 46.995L85.6537 47.4094C86.0925 47.7262 86.6287 47.8969 87.165 47.8969H87.2137C89.0906 47.8969 89.3344 46.3612 89.3344 44.4844V44.46C89.3344 42.5831 87.7987 41.0475 85.9219 41.0475H78.4144C76.5375 41.0475 75.0019 42.5831 75.0019 44.46C75.0019 46.3369 76.5375 47.8725 78.4144 47.8725Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7543 47.8725H81.0712C81.6074 47.8725 82.1437 47.7019 82.5824 47.385L83.0943 47.0194C83.9962 46.3612 85.2149 46.3612 86.1168 46.995L86.7018 47.4094C87.1406 47.7262 87.6768 47.8969 88.2131 47.8969H88.2618C90.1387 47.8725 91.6743 46.3612 91.6743 44.4844V44.46C91.6743 42.5831 90.1387 41.0475 88.2618 41.0475H80.7543C78.8774 41.0475 77.3418 42.5831 77.3418 44.46C77.2931 46.3369 78.8531 47.8725 80.7543 47.8725Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8381 85.8975V156.634H74.6118V94.9894C74.6118 89.9925 70.5656 85.9219 65.5687 85.8975C65.5443 85.8975 65.5443 85.8975 65.5443 85.8975H24.8381Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7644 92.1863V156.609H79.3894V92.1863C79.3894 88.7007 76.5619 85.8975 73.1006 85.8975H71.0775C67.7869 85.8975 65.0569 88.4082 64.7888 91.6744C64.7888 91.845 64.7644 92.0157 64.7644 92.1863Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3756 85.8975L64.7887 91.5525C64.7887 91.5525 64.7887 91.5769 64.8131 91.65C64.9837 92.5275 66.2756 98.3531 70.395 99.1575C71.8331 99.45 73.2956 99.1331 74.6362 98.5481C77.3419 97.3781 79.4381 95.2087 79.4381 95.2087V92.1619C79.4381 88.6762 76.6106 85.8731 73.1494 85.8731H73.125L62.3756 85.8975Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9457 69.3225L76.83 76.245L71.5894 65.6419C69.8588 61.9613 65.4713 60.4013 61.7906 62.1319C58.11 63.8625 56.55 68.25 58.2806 71.9306C58.305 72.0038 58.3538 72.0769 58.3781 72.15L67.3481 90.3338L67.5188 90.6994C69.225 94.185 73.4419 95.5988 76.9275 93.8925C77.4638 93.6244 77.9756 93.2831 78.4388 92.8931L93.4781 79.755L86.9457 69.3225Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5513 79.755L99.5475 74.5388C101.961 72.5156 102.278 68.8838 100.254 66.4706C98.3288 64.1794 94.965 63.765 92.5275 65.4956L86.9457 69.3225L93.5513 79.755Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9351 86.2144C64.9594 86.2144 65.0082 86.2144 65.0325 86.19C65.1544 86.1169 65.2275 85.9706 65.1544 85.8487L60.1088 75.2944C60.0357 75.1725 59.8894 75.0994 59.7675 75.1725C59.6457 75.2456 59.5725 75.3919 59.6457 75.5137L64.6913 86.0681C64.7401 86.1656 64.8376 86.2144 64.9351 86.2144Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7324 76.635L87.0918 69.5419C87.2137 69.4444 87.2624 69.2981 87.1649 69.1762C87.0674 69.0544 86.9212 69.0056 86.7993 69.1031L76.9518 75.855L72.3206 66.495C72.2474 66.3731 72.1012 66.3244 71.9793 66.3731C71.8574 66.4462 71.8087 66.5925 71.8574 66.7144L76.7324 76.635Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.169 132.844C161.192 132.844 162.849 131.186 162.849 129.163C162.849 128.554 162.703 127.993 162.435 127.457L135.671 76.8056C134.721 75.0019 132.502 74.3194 130.723 75.27C128.944 76.2206 128.237 78.4388 129.187 80.2181L155.927 130.894C156.561 132.088 157.804 132.844 159.169 132.844Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.056 97.6707L141.814 104.228L138.377 97.6707H144.056Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.869 75.5869C131.649 75.5869 132.381 75.27 132.917 74.685L134.453 73.0031C135.452 71.9306 136.841 71.3213 138.304 71.3213H151.978C153.489 71.2725 154.684 70.005 154.635 68.4694C154.586 67.0312 153.416 65.8613 151.978 65.8125H138.279C135.257 65.8125 132.381 67.08 130.358 69.3225L128.822 71.0044C127.798 72.1256 127.896 73.8806 129.017 74.9044C129.529 75.3187 130.187 75.5869 130.869 75.5869Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.318 75.5869C116.829 75.5869 118.073 74.3438 118.073 72.8325C118.073 72.15 117.829 71.4919 117.341 70.98L115.806 69.2981C113.783 67.08 110.906 65.8125 107.884 65.7881H94.185C92.6738 65.7881 91.4306 67.0313 91.4306 68.5425C91.4306 70.0538 92.6738 71.2969 94.185 71.2969H107.884C109.346 71.2969 110.736 71.9063 111.735 72.9788L113.271 74.6606C113.807 75.27 114.538 75.5869 115.318 75.5869Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.899 88.6519H125.044C130.626 88.5787 135.111 83.9719 135.037 78.39C134.964 72.9056 130.528 68.4694 125.044 68.3962H121.924C116.342 68.4694 111.857 73.0762 111.93 78.6581C111.979 84.1425 116.415 88.5787 121.899 88.6519ZM125.044 73.905C127.603 73.905 129.675 75.9769 129.675 78.5362C129.675 81.0956 127.603 83.1675 125.044 83.1675H121.924C119.364 83.1675 117.292 81.0956 117.292 78.5362C117.292 75.9769 119.364 73.905 121.924 73.905H125.044Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.044 85.8731C120.978 85.8731 117.683 82.5774 117.683 78.5119C117.683 74.4464 120.978 71.1506 125.044 71.1506C129.109 71.1506 132.405 74.4464 132.405 78.5119C132.405 82.5774 129.109 85.8731 125.044 85.8731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.044 88.6519C130.626 88.6519 135.184 84.1181 135.184 78.5119C135.184 72.93 130.65 68.3719 125.044 68.3719C119.462 68.3719 114.904 72.9056 114.904 78.5119C114.879 84.1181 119.413 88.6519 125.044 88.6519ZM125.044 73.905C127.603 73.905 129.675 75.9769 129.675 78.5363C129.675 81.0956 127.603 83.1675 125.044 83.1675C122.484 83.1675 120.412 81.0956 120.412 78.5363C120.388 75.9525 122.484 73.905 125.044 73.905Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.571 133.307C139.571 145.836 137.694 156.049 146.933 156.609C147.201 156.634 156.707 156.634 156.975 156.634C166.579 156.634 174.379 146.201 174.379 133.307C174.379 120.412 166.579 109.98 156.975 109.98C156.756 109.98 145.787 109.98 145.543 110.004C136.256 110.467 139.571 120.729 139.571 133.307Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.226 156.634C136.614 156.634 128.822 146.19 128.822 133.307C128.822 120.424 136.614 109.98 146.226 109.98C155.837 109.98 163.629 120.424 163.629 133.307C163.629 146.19 155.837 156.634 146.226 156.634Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.842 133.307C134.842 141.741 139.937 148.566 146.226 148.566C149.614 148.566 152.636 146.591 154.732 143.423C156.487 140.741 157.584 137.183 157.584 133.307C157.584 129.431 156.512 125.873 154.708 123.191C152.636 120.047 149.565 118.048 146.201 118.048C139.937 118.048 134.842 124.873 134.842 133.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.645 133.307C138.645 138.913 142.033 143.447 146.201 143.447C146.299 143.447 150.686 143.447 154.708 143.447C156.487 140.741 157.584 137.183 157.584 133.307C157.584 129.431 156.512 125.873 154.708 123.191C150.784 123.191 146.299 123.191 146.201 123.191C142.033 123.167 138.645 127.701 138.645 133.307Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.645 133.38C138.645 133.892 138.669 134.404 138.718 134.891C138.938 136.963 139.571 138.816 140.473 140.278C141.716 142.228 143.471 143.447 145.421 143.447C149.151 143.447 152.198 138.938 152.198 133.38C152.198 127.823 149.175 123.289 145.446 123.289C141.716 123.289 138.645 127.798 138.645 133.38Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.743 134.891C138.962 136.963 139.596 138.816 140.498 140.278C145.787 139.742 145.226 132.454 145.226 132.454L139.571 132.868C139.254 133.526 138.962 134.184 138.743 134.891Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.873 89.0906C127.749 89.0906 129.163 88.5056 130.114 87.9206C131.479 87.0675 132.186 86.0925 132.186 86.0437C132.283 85.9218 132.234 85.7512 132.113 85.6781C131.991 85.605 131.82 85.6293 131.747 85.7512C131.747 85.7756 131.089 86.7018 129.797 87.5062C128.066 88.5543 126.092 88.8468 123.898 88.3593C123.752 88.335 123.606 88.4081 123.581 88.5543C123.557 88.7006 123.63 88.8468 123.776 88.8712C124.532 89.0175 125.214 89.0906 125.873 89.0906Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57 136.378C143.593 136.378 145.251 134.745 145.251 132.698C145.251 132.137 145.104 131.576 144.861 131.064L117.829 76.9032C116.951 75.075 114.757 74.295 112.929 75.1725C111.101 76.05 110.321 78.2438 111.199 80.0719C111.223 80.0963 111.223 80.145 111.247 80.1938L138.304 134.331C138.889 135.574 140.156 136.354 141.57 136.378Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.813 92.2594H117.293L120.315 98.3288H147.03L143.813 92.2594Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.153 63.3019H140.693C139.961 63.3019 139.352 63.9113 139.352 64.6425C139.352 67.3481 141.546 69.5419 144.251 69.5419H145.884C147.688 69.5419 149.151 68.0794 149.151 66.2756C149.151 64.6425 147.81 63.3019 146.153 63.3019Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.206 64.4719H94.7456C94.0144 64.4719 93.405 65.0812 93.405 65.8125C93.405 68.5181 95.5987 70.7119 98.3044 70.7119H99.9375C101.741 70.7119 103.204 69.2494 103.204 67.4456C103.204 65.8125 101.863 64.4719 100.206 64.4719Z",
    fill: "#EA7068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6575 129.236C79.8038 129.236 79.9257 129.114 79.9257 128.968V112.978C79.9257 112.832 79.8038 112.71 79.6575 112.71C79.5113 112.71 79.3894 112.832 79.3894 112.978V128.968C79.3894 129.114 79.5113 129.236 79.6575 129.236Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.604 98.5969H128.505C128.651 98.5969 128.773 98.475 128.773 98.3287C128.773 98.1825 128.651 98.0606 128.505 98.0606H125.604C125.458 98.0606 125.336 98.1825 125.336 98.3287C125.336 98.475 125.482 98.5969 125.604 98.5969Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.757 31.9556C154.353 31.9556 154.026 31.6282 154.026 31.2244C154.026 30.8205 154.353 30.4931 154.757 30.4931C155.161 30.4931 155.488 30.8205 155.488 31.2244C155.488 31.6282 155.161 31.9556 154.757 31.9556Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1356 105.081C16.7317 105.081 16.4043 104.753 16.4043 104.349C16.4043 103.946 16.7317 103.618 17.1356 103.618C17.5394 103.618 17.8668 103.946 17.8668 104.349C17.8668 104.753 17.5394 105.081 17.1356 105.081Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4188 38.9513C32.0149 38.9513 31.6875 38.6239 31.6875 38.22C31.6875 37.8162 32.0149 37.4888 32.4188 37.4888C32.8226 37.4888 33.15 37.8162 33.15 38.22C33.15 38.6239 32.8226 38.9513 32.4188 38.9513Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.713 22.9613C107.309 22.9613 106.982 22.6339 106.982 22.23C106.982 21.8262 107.309 21.4988 107.713 21.4988C108.117 21.4988 108.444 21.8262 108.444 22.23C108.444 22.6339 108.117 22.9613 107.713 22.9613Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.648 104.788C173.244 104.788 172.916 104.461 172.916 104.057C172.916 103.653 173.244 103.326 173.648 103.326C174.051 103.326 174.379 103.653 174.379 104.057C174.379 104.461 174.051 104.788 173.648 104.788Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3575 119.608V157.463L76.0743 156.634C64.4718 156.634 60.645 145.202 55.1362 136.208C52.1625 131.357 48.7012 127.213 43.2656 125.97C37.2937 124.605 33.9543 120.315 31.1756 115.562C31.0537 115.367 30.9562 115.148 30.8343 114.953C26.0325 106.665 13.3575 110.029 13.3575 119.608Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0769 154.513L71.2969 154.489C71.565 154.513 71.8088 154.513 72.0769 154.513Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.218 140.229C119.243 141.887 119.949 143.471 121.217 144.568C125.361 148.249 126.287 156.658 132.893 156.658H147.03C139.108 156.658 139.376 144.666 132.478 143.057C129.724 142.423 128.237 140.4 126.969 138.182C124.849 134.477 119.218 135.964 119.218 140.229Z",
    fill: "url(#paint30_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 162.538,
    y1: 16.3852,
    x2: 162.538,
    y2: 32.4301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 132.405,
    y1: 39.9525,
    x2: 132.405,
    y2: 53.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 165.325,
    y1: 136.833,
    x2: 165.325,
    y2: 155.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 46.3602,
    y1: 88.2774,
    x2: 46.3602,
    y2: 129.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 55.6287,
    y1: 156.291,
    x2: 55.6287,
    y2: 62.7718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 69.474,
    y1: 88.2774,
    x2: 69.474,
    y2: 129.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 106.989,
    y1: 156.293,
    x2: 106.989,
    y2: 62.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 104.587,
    y1: 57.252,
    x2: 104.587,
    y2: 90.2573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA979A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F2D38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7E9DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#90979D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EBDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 100.01,
    y1: 110.67,
    x2: 100.01,
    y2: 92.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A1978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C9A780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F7B96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 73.5077,
    y1: 200.238,
    x2: 73.5077,
    y2: 85.2261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A1978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C9A780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F7B96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 102.774,
    y1: 131.881,
    x2: 102.774,
    y2: 113.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 107.909,
    y1: 84.1412,
    x2: 107.909,
    y2: 111.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 100.969,
    y1: 116.326,
    x2: 100.969,
    y2: 126.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 109.474,
    y1: 118.647,
    x2: 94.4822,
    y2: 118.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 108.234,
    y1: 121.452,
    x2: 93.2422,
    y2: 121.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 106.992,
    y1: 124.274,
    x2: 92.0005,
    y2: 124.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 101.103,
    y1: 113.585,
    x2: 101.103,
    y2: 133.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 73.2777,
    y1: 57.0608,
    x2: 73.2777,
    y2: 95.1189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA979A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F2D38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7E9DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#90979D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EBDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 86.7098,
    y1: 127.806,
    x2: 86.7098,
    y2: 88.4943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77879D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A1978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C9A780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F7B96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDBB6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDBB9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECEAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 49.72,
    y1: 154.24,
    x2: 49.72,
    y2: 113.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 72.0756,
    y1: 156.291,
    x2: 72.0756,
    y2: 62.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD02D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 73.27,
    y1: 57.1433,
    x2: 78.1283,
    y2: 93.9946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA979A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F2D38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7E9DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#90979D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EBDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 145.782,
    y1: 119.884,
    x2: 145.782,
    y2: 79.4128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 113.372,
    y1: 78.5133,
    x2: 121.665,
    y2: 78.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 135.174,
    y1: 78.5045,
    x2: 114.891,
    y2: 78.5045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 148.128,
    y1: 144.627,
    x2: 148.128,
    y2: 121.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 145.421,
    y1: 124.759,
    x2: 145.421,
    y2: 144.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 128.016,
    y1: 119.884,
    x2: 128.016,
    y2: 79.4128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 132.158,
    y1: 100.193,
    x2: 132.158,
    y2: 88.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9774AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#47A6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A7A7AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E89AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFE7D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 44.7286,
    y1: 118.714,
    x2: 44.7286,
    y2: 155.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 133.128,
    y1: 139.761,
    x2: 133.128,
    y2: 155.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 190.491,
    fill: "white",
    transform: "matrix(-1 0 0 1 195 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginaliaVirtualReality);
export default __webpack_public_path__ + "static/media/marginalia-virtual-reality.ce4cfd76.svg";
export { ForwardRef as ReactComponent };